import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityBlogApi, FilterEntityBlogOptions } from 'api';

export const filterEntityBlog = createAsyncThunk(
  'entityBlog/filterEntityArea',
  async (option: FilterEntityBlogOptions, { rejectWithValue }) => {
    try {
      const response = await EntityBlogApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityBlog = createAsyncThunk(
  'entityBlog/createEntityArea',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityBlogApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityBlog = createAsyncThunk(
  'entityBlog/findOneEntityBlog',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityBlogApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityBlog = createAsyncThunk(
  'entityBlog/updateEntityArea',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityBlogApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityBlog = createAsyncThunk(
  'entityBlog/removeEntityArea',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityBlogApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  query: {},
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entityBlogSlice = createSlice({
  name: 'entityBlog',
  initialState,
  reducers: {
    reloadEntityBlog(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityBlog(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityBlog(state, action) {
      state.savedList = action.payload;
    },
  },
  // extraReducers: builder => {},
});

const { actions, reducer: entityBlogReducer } = entityBlogSlice;

export const {
  reloadEntityBlog,
  updateSavedPaginationEntityBlog,
  updateSavedListEntityBlog,
} = actions;

export default entityBlogReducer;
